// Generated by scripts/generate-popular-material-icons.mjs — do not edit by hand.
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ComponentType } from 'react';

import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import EmailIcon from '@mui/icons-material/Email';
import MailIcon from '@mui/icons-material/Mail';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import PhoneIcon from '@mui/icons-material/Phone';
import CallIcon from '@mui/icons-material/Call';
import SmsIcon from '@mui/icons-material/Sms';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PlaceIcon from '@mui/icons-material/Place';
import MapIcon from '@mui/icons-material/Map';
import DirectionsIcon from '@mui/icons-material/Directions';
import NavigationIcon from '@mui/icons-material/Navigation';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EventIcon from '@mui/icons-material/Event';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TodayIcon from '@mui/icons-material/Today';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import GroupIcon from '@mui/icons-material/Group';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import LinkIcon from '@mui/icons-material/Link';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ImageIcon from '@mui/icons-material/Image';
import PhotoIcon from '@mui/icons-material/Photo';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import BookIcon from '@mui/icons-material/Book';
import EditIcon from '@mui/icons-material/Edit';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PaymentIcon from '@mui/icons-material/Payment';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import HikingIcon from '@mui/icons-material/Hiking';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import ParkIcon from '@mui/icons-material/Park';
import ForestIcon from '@mui/icons-material/Forest';
import TerrainIcon from '@mui/icons-material/Terrain';
import FlagIcon from '@mui/icons-material/Flag';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import TimerIcon from '@mui/icons-material/Timer';
import AlarmIcon from '@mui/icons-material/Alarm';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CampaignIcon from '@mui/icons-material/Campaign';
import ShareIcon from '@mui/icons-material/Share';
import PrintIcon from '@mui/icons-material/Print';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';
import SettingsIcon from '@mui/icons-material/Settings';
import BuildIcon from '@mui/icons-material/Build';
import ConstructionIcon from '@mui/icons-material/Construction';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import WcIcon from '@mui/icons-material/Wc';
import AccessibleIcon from '@mui/icons-material/Accessible';
import PetsIcon from '@mui/icons-material/Pets';
import CloudIcon from '@mui/icons-material/Cloud';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';

export const POPULAR_MATERIAL_ICON_COMPONENTS: Record<string, ComponentType<SvgIconProps>> = {
  Inbox: InboxIcon,
  Drafts: DraftsIcon,
  Email: EmailIcon,
  Mail: MailIcon,
  MarkEmailRead: MarkEmailReadIcon,
  Phone: PhoneIcon,
  Call: CallIcon,
  Sms: SmsIcon,
  LocationOn: LocationOnIcon,
  Place: PlaceIcon,
  Map: MapIcon,
  Directions: DirectionsIcon,
  Navigation: NavigationIcon,
  MyLocation: MyLocationIcon,
  Schedule: ScheduleIcon,
  Event: EventIcon,
  CalendarToday: CalendarTodayIcon,
  Today: TodayIcon,
  AccessTime: AccessTimeIcon,
  Info: InfoIcon,
  Help: HelpIcon,
  HelpOutlineOutlined: HelpOutlineOutlinedIcon,
  CheckCircle: CheckCircleIcon,
  Check: CheckIcon,
  Close: CloseIcon,
  Cancel: CancelIcon,
  Warning: WarningIcon,
  Error: ErrorIcon,
  ErrorOutlined: ErrorOutlinedIcon,
  Star: StarIcon,
  StarBorder: StarBorderIcon,
  Favorite: FavoriteIcon,
  FavoriteBorder: FavoriteBorderIcon,
  Home: HomeIcon,
  Person: PersonIcon,
  People: PeopleIcon,
  Group: GroupIcon,
  Search: SearchIcon,
  Download: DownloadIcon,
  Upload: UploadIcon,
  Link: LinkIcon,
  AttachFile: AttachFileIcon,
  Image: ImageIcon,
  Photo: PhotoIcon,
  MenuBook: MenuBookIcon,
  Book: BookIcon,
  Edit: EditIcon,
  Create: CreateIcon,
  Add: AddIcon,
  Remove: RemoveIcon,
  Delete: DeleteIcon,
  ArrowForward: ArrowForwardIcon,
  ArrowBack: ArrowBackIcon,
  ExpandMore: ExpandMoreIcon,
  ExpandLess: ExpandLessIcon,
  Visibility: VisibilityIcon,
  VisibilityOff: VisibilityOffIcon,
  Lock: LockIcon,
  LockOpen: LockOpenIcon,
  Payment: PaymentIcon,
  CreditCard: CreditCardIcon,
  LocalOffer: LocalOfferIcon,
  Restaurant: RestaurantIcon,
  LocalCafe: LocalCafeIcon,
  WaterDrop: WaterDropIcon,
  Hiking: HikingIcon,
  DirectionsBike: DirectionsBikeIcon,
  DirectionsRun: DirectionsRunIcon,
  DirectionsWalk: DirectionsWalkIcon,
  Park: ParkIcon,
  Forest: ForestIcon,
  Terrain: TerrainIcon,
  Flag: FlagIcon,
  EmojiEvents: EmojiEventsIcon,
  MilitaryTech: MilitaryTechIcon,
  Timer: TimerIcon,
  Alarm: AlarmIcon,
  Notifications: NotificationsIcon,
  Campaign: CampaignIcon,
  Share: ShareIcon,
  Print: PrintIcon,
  Save: SaveIcon,
  Refresh: RefreshIcon,
  Settings: SettingsIcon,
  Build: BuildIcon,
  Construction: ConstructionIcon,
  HealthAndSafety: HealthAndSafetyIcon,
  MedicalServices: MedicalServicesIcon,
  LocalHospital: LocalHospitalIcon,
  Wc: WcIcon,
  Accessible: AccessibleIcon,
  Pets: PetsIcon,
  Cloud: CloudIcon,
  WbSunny: WbSunnyIcon,
  AcUnit: AcUnitIcon,
  Thunderstorm: ThunderstormIcon,
};
